import React from 'react';
import { Link, Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

import {
  MarketoForm,
  MarketoFormProps,
} from '@bizapp-lp/pjr/molecules/MarketoForm';

export type MarketoFormComponentProps = {
  className?: string;
  marketoForm?: MarketoFormProps;
  children?: React.ReactNode;
};

export const MarketoFormComponent: React.FC<MarketoFormComponentProps> = ({
  className,
  marketoForm,
  children,
}) => {
  const RootContainer = styled('section')(({ theme }) => ({
    margin: 0,
    maxWidth: '464px',
    paddingBottom: '32px',
    background: '#ffffff',
    boxShadow: '0px 16px 32px #00000014',
    '&:before': {
      content: '""',
      display: 'block',
      height: '6px',
      background: `transparent linear-gradient(90deg, ${theme.palette.themeColor.gradationBegin} 0%, ${theme.palette.themeColor.gradationEnd} 100%) 0% 0% no-repeat padding-box`,
    },
  }));

  const ContentContainer = styled('div')(({ theme }) => ({
    margin: '32px 32px 0 32px',
    width: 'auto',
  }));

  const DescriptionBox = styled('div')(({ theme }) => ({
    marginTop: 0,
    marginBottom: '32px',
    fontSize: '14px',
    lineHeight: '21px',
    color: '#333333',
    textAlign: 'center',
    '& > *': {
      display: 'block',
    },
  }));

  const IconBox = styled('div')(({ theme }) => ({
    textAlign: 'center',
    marginTop: 0,
    marginBottom: '32px',
    '& > *': {
      verticalAlign: 'top',
      height: '64px',
      width: '64px',
    },
  }));

  const FormBox = styled('div')(({ theme }) => ({}));

  const GrecaptchaComponent = styled('p')(({ theme }) => ({
    marginTop: '12px',
    color: '#7f7f7f',
    fontSize: '12px',
    lineHeight: '18px',
    textAlign: 'center',
    '& span': {
      display: 'block',
    },
    '& .MuiLink-root': {
      color: '#1565c0',
    },
  }));

  return (
    <RootContainer className={className}>
      <ContentContainer>
        {children && <DescriptionBox>{children}</DescriptionBox>}
        <IconBox>
          <img
            src={`${process.env.PUBLIC_URL}/images/icon-project-room.png`}
            alt="Project Room Logo"
          />
        </IconBox>
        <FormBox>
          <MarketoForm {...marketoForm} />
        </FormBox>
        <Typography component={GrecaptchaComponent}>
          <span>このサイトはreCAPTCHAによって保護されており、</span>
          <span>
            Googleの
            <Link
              href="https://policies.google.com/privacy"
              target={'_blank'}
              rel={'noreferrer'}
            >
              プライバシーポリシー
            </Link>
            と
            <Link
              href="https://policies.google.com/terms"
              target={'_blank'}
              rel={'noreferrer'}
            >
              利用規約
            </Link>
            が適用されます。
          </span>
        </Typography>
      </ContentContainer>
    </RootContainer>
  );
};
